module.exports = __webpack_public_path__ + "static/thumbnail-31a0378aa9a32f8d971401190646e056.png";